import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["file", "submitButton"];

  connect() {
    this.refresh();
  }

  refresh() {
    if (!this.hasSubmitButtonTarget) return;
    const hasFile = this.hasFileTarget && this.fileTarget.files.length > 0;
    this.submitButtonTarget.disabled = !hasFile;
  }
}
